// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__pRzi9","header":"ReportDetails_header__gpTEz","title":"ReportDetails_title__ZMRi5","left":"ReportDetails_left__2fWpW"};